<button type="button" class="btn btn-primary" matTooltip="{{ 'save_and_preview' | translate }}" [disabled]="isDisabled || (isInProgress$ | async)">
  <button-icon-loader [isLoading]="isInProgress$ | async" [defaultIcon]="['fas', 'save']"></button-icon-loader>
  <span class="ml-1">{{ 'save_and_preview' | translate }}</span>
</button>
